import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { from, Observable } from 'rxjs';
import * as translate from "translate";

@Component({
    selector: 'mono-common-input-with-done-button',
    templateUrl: './input-with-done-button.component.html',
})
export class InputWithDoneButtonComponent implements OnInit {

  private readonly defaultLanguage = "en";

  @Input() disableDoneButton = false;
  @Input() language: string = this.defaultLanguage;
  @Input() buttonText?: string;

  @Output() doneButtonClick = new EventEmitter();

  public doneText: Observable<string>;

  constructor() { }

  ngOnInit(): void {
    this.doneText = from<string>(translate(this.buttonText ? this.buttonText : "Done", this.language));
  }

  public doneButtonClicked() {
    this.doneButtonClick.emit();
  }

}